var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKucoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 26 28",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m8.07119 13.984 8.28181 8.2831 5.2276-5.2275c.9347-.8417 2.3648-.8042 3.2542.0852s.9269 2.3195.0852 3.2542l-6.8985 6.8999c-.9267.9113-2.4128.9113-3.3395 0l-9.95283-9.9555v5.9173c0 1.3059-1.05866 2.3646-2.36458 2.3646-1.30593 0-2.36459-1.0587-2.36459-2.3646v-18.52111c0-1.30592 1.05866-2.36458 2.36459-2.36458 1.30592 0 2.36458 1.05866 2.36458 2.36458v5.91721l9.95153-9.952801c.9264-.911999 2.4131-.911999 3.3395 0l6.9037 6.898531c.8416.93475.8042 2.36482-.0853 3.25427-.8894.8894-2.3194.9268-3.2542.0852l-5.2275-5.22754zm8.28571-2.3672c-.9576-.0005-1.8211.5759-2.1879 1.4604s-.1646 1.9029.5123 2.5802c.6769.6772 1.6952.88 2.5799.5137s1.4616-1.2296 1.4616-2.1871c.0003-.6278-.2488-1.23-.6925-1.6742s-1.0456-.6939-1.6734-.6942z",
    fill: "#23af91",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKucoin);
export default __webpack_public_path__ + "static/media/kucoin.e57aa16b728d0d86b4570992557888a7.svg";
export { ForwardRef as ReactComponent };